import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d80e860")

_pushScopeId("data-v-2d80e860")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "nav__title" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_OInputText = _resolveComponent("OInputText")
  const _component_FormField = _resolveComponent("FormField")
  const _component_OCheckbox = _resolveComponent("OCheckbox")
  const _component_UserLog = _resolveComponent("UserLog")
  const _component_OButton = _resolveComponent("OButton")
  const _component_BlockUI = _resolveComponent("BlockUI")
  const _directive_focus = _resolveDirective("focus")
  const _directive_uppercase = _resolveDirective("uppercase")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, { blocked: _ctx.busy }, {
      default: _withId(() => [
        _createVNode(_component_NavBar, { navigation: "back" }, {
          body: _withId(() => [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_FormField, {
              label: "Nome",
              invalid: _ctx.v$.form.name.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Nome inválido.",
              "data-test": "fieldName"
            }, {
              default: _withId(() => [
                _withDirectives(_createVNode(_component_OInputText, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                  placeholder: "Nome",
                  "data-test": "name",
                  class: { 'p-invalid': _ctx.v$.form.name.$invalid && _ctx.submitted }
                }, null, 8, ["modelValue", "class"]), [
                  [_directive_focus],
                  [_directive_uppercase]
                ])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Inativo",
              loading: _ctx.loading
            }, {
              default: _withId(() => [
                _createVNode(_component_OCheckbox, {
                  modelValue: _ctx.form.inactive,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.inactive = $event)),
                  binary: true,
                  "data-test": "inactive"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_UserLog, {
            class: "user-log",
            data: _ctx.userLog
          }, null, 8, ["data"]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_OButton, {
              class: "p-button-primary",
              "icon-pos": "right",
              label: "SALVAR",
              loading: _ctx.saving,
              "data-test": "save",
              onClick: _ctx.handleSave
            }, null, 8, ["loading", "onClick"]),
            (_ctx.editing)
              ? (_openBlock(), _createBlock(_component_OButton, {
                  key: 0,
                  class: "p-button-danger p-button-outlined",
                  "icon-pos": "right",
                  label: "DELETAR",
                  loading: _ctx.deleting,
                  "data-test": "delete",
                  onClick: _ctx.handleDelete
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"])
  ]))
})